'use client'

import { Button } from '@/core/ui/atoms/button'
import { Modal, ModalBody } from '@/core/ui/atoms/modal'
import { useDisclosure } from '@heroui/react'
import { Pencil } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { UpdatePassword } from '../update-password'
import { UpdateProfile } from '../update-profile'
import { UserDetailsModel } from '@/features/auth/types/models/user-details.model'
import { useDeleteProfileImage } from '../../hooks/use-delete-profile-image'
import { useState } from 'react'

export function ProfileDetails({ user }: { user: UserDetailsModel | null }) {
  const t = useTranslations()
  const [preview, setPreview] = useState<string | null>(null)

  const {
    isOpen: isUpdateProfileOpen,
    onClose: onCloseUpdateProfile,
    onOpen: onOpenUpdateProfile,
  } = useDisclosure()
  const {
    isOpen: isUpdatePasswordOpen,
    onClose: onCloseUpdatePassword,
    onOpen: onOpenUpdatePassword,
  } = useDisclosure()
  const { deleteImage, isDeleting } = useDeleteProfileImage({
    onSuccess: () => {
      setPreview(null)
    },
  })
  return (
    <>
      <div className='w-full rounded bg-white p-6'>
        <div className='flex items-center justify-between text-2xl font-semibold'>
          <div className='flex items-center gap-3'>
            <div
              style={{ height: '70px', width: '70px' }}
              className='relative rounded-full'
            >
              <Image
                src={user?.image || '/images/avatar.png'}
                alt=''
                width={70}
                height={70}
                className='h-full w-full rounded-full object-cover'
              />
              <Button
                color='medium-gray'
                type='button'
                className='absolute top-10 mt-1 h-1 w-1 cursor-pointer p-0'
                onClick={() => deleteImage()}
                loading={isDeleting}
                disabled={!user?.image && !preview}
                style={{
                  position: 'absolute',
                  top: '42px',
                  right: '-4px',
                  color: '#fff',
                  fontSize: '18px',
                  backgroundColor: '#ca2a30',
                  width: '28px',
                  height: '28px',
                  border: '3px solid white',
                  borderRadius: '50%',
                }}
              >
                x
              </Button>
            </div>

            <p className='text-2xl font-semibold'>{user?.username}</p>
          </div>
          <Button
            color='creamed-cron'
            radius='full'
            className='h-8 w-8 p-2'
            onClick={onOpenUpdateProfile}
          >
            <Pencil className='text-mountain-bluebird w-4' />
          </Button>
        </div>
        <p className='mt-3 text-xl font-semibold'>{user?.email}</p>
        <p className='text-xl font-semibold'>{user?.phone}</p>

        <Button
          color='cyan-blue'
          variant='text'
          className='my-3 p-0 text-lg font-semibold'
          onClick={onOpenUpdatePassword}
        >
          {t('actions.changePassword')}
        </Button>
      </div>
      <Modal
        isOpen={isUpdateProfileOpen}
        onClose={onCloseUpdateProfile}
        disableBackdropDismiss
      >
        <ModalBody>
          <UpdateProfile onSuccess={onCloseUpdateProfile} user={user} />
        </ModalBody>
      </Modal>
      <Modal
        isOpen={isUpdatePasswordOpen}
        onClose={onCloseUpdatePassword}
        disableBackdropDismiss
      >
        <ModalBody>
          <UpdatePassword onSuccess={onCloseUpdatePassword} />
        </ModalBody>
      </Modal>
    </>
  )
}
